import {
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  material_code,
  amount,
  unit,
  remarks,
} from '@/table/Job/SubJob/base';

export default {
  types: {
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    material_code: {
      ...material_code,
      width: '1fr',
    },
    amount: {
      ...amount,
      name: 'จำนวนทั้งหมด',
      width: '6rem',
    },
    store_amount: {
      name: 'จำนวนในคลัง',
      width: '5rem',
      class: 'text-right',
      filter: (val: any, row: any) => (row.item.store_amount || 0) + (row.item.assembly_pending_amount || 0),
    },
    assembly_pending_amount: {
      ...amount,
      name: 'จำนวนขอเบิก',
      width: '6rem',
    },
    unit,
    remarks,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    'qc_store_amount',
    'unit',
    'assembly_pending_amount',
  ],
};
